import { ProfileSectionProps } from "./types";
import { FormSection } from "@/features/common/components/FormSection";
import { DataField } from "@/features/common/components/DataField";
import { InsuranceFields } from "./Insurance/InsuranceFields";

// Label mapping function
const getStatusLabel = (value: string) => {
  const labels: { [key: string]: string } = {
    not_started: "Nicht begonnen",
    in_progress: "In Bearbeitung",
    completed: "Abgeschlossen",
    pending: "Ausstehend",
    approved: "Genehmigt",
    rejected: "Abgelehnt",
    not_required: "Nicht erforderlich",
    not_applicable: "Nicht zutreffend"
  };
  return labels[value] || value;
};

export function InsuranceSection({
  profile,
  setProfile,
  readOnly
}: ProfileSectionProps) {
  return (
    <FormSection title="Versicherung">
      <InsuranceFields
        profile={profile}
        setProfile={setProfile}
        readOnly={readOnly}
      />
    </FormSection>
  );
}

// View component
export function InsuranceView({ profile }: { profile: any }) {
  return (
    <div className="space-y-1">
      <DataField
        label="Krankenversicherung Status"
        value={
          profile.health_insurance_status
            ? getStatusLabel(profile.health_insurance_status)
            : null
        }
      />
    </div>
  );
}
